import Basic from "./Basic.jsx";
import IconField from "./IconField.jsx";
import SearchTextField from "./SearchTextField.jsx";
import SelectField from "./SelectField.jsx";
import Textarea from "./TextArea.jsx";

export default {
  Basic,
  SelectField,
  Autocomplete: SearchTextField,
  IconField,
  Textarea,
};
